import { QuizManager } from "@/components/quiz/quiz-manager"

export default function QuizPage() {
  return (
    <div className="container mx-auto py-6">
      <div className="max-w-2xl mx-auto space-y-6">
        <QuizManager />
      </div>
    </div>
  )
}